import { LinkOutlined } from '@ant-design/icons'
import { addCommasToNumber, Texto } from '@gravitate-js/excalibrr'
import React from 'react'
import { ReadableDifference, ShowRunOutWarningClass, TankHasWarning } from '../../../../utils/general'
import { FlagIcon } from '../../../_SiteWide/Flags/FlagIcon'
import { TankFillBar } from '../../../_SiteWide/TankDisplay/TankFillBar'
import { TankOrderStatusPopover } from './TankOrderStatusPopover'
import { useSiteMonitoringContext } from '@components/StoreMonitoring/SiteMonitoringContext'

export const tankColumns = (rundownToggled, monitoringStrategy, allTankData) => {
  const { sortedInfo } = useSiteMonitoringContext()

  return [
    {
      title: '',
      dataIndex: 'flags',
      key: 'flags',
      width: 50,
      render: (value, tank) => {
        const showStoreFlags = tank.flags && tank.flags.length > 0
        return showStoreFlags ? (
          <div className='flex justify-center'>
            <FlagIcon hideRunout={false} flags={tank.flags} hideOrderNumber allowCarrierVisibility />
          </div>
        ) : null
      },
    },
    {
      title: '',
      dataIndex: 'has_order',
      key: 'has_order',
      width: 50,
      render: (value, row) => (
        <div className='flex justify-center'>
          <TankOrderStatusPopover status={row.order_status} orderId={row.order_id} row={row} />
        </div>
      ),
    },
    {
      title: 'Tank IDs',
      key: 'tanks_ids',
      width: 60,
      sortOrder: sortedInfo?.columnKey === 'tanks_ids' ? sortedInfo?.order : null,
      sorter: (a, b) => a.tank_id - b.tank_id,
      render: (_, tank) => {
        return `TANK ${tank.tank_ids ? JSON.stringify(tank.tank_ids) : tank.tank_id}`
      },
    },
    {
      title: 'Product',
      dataIndex: 'product',
      key: 'product',
      width: 120,
      render: (text, row) => (
        <Texto category='p2' weight='bold' appearance={row.manifold_id && 'secondary'}>
          {row.manifold_id && <LinkOutlined className='pr-3' />}
          {text}
        </Texto>
      ),
    },

    {
      title: 'RunOut Time',
      dataIndex: 'run_out_date',
      key: 'run_out_date',
      width: 100,
      defaultSortOrder: 'desc',
      sortOrder: sortedInfo?.columnKey === 'run_out_date' ? sortedInfo?.order : null,
      sorter: (a, b) => {
        if (monitoringStrategy === 'No Readings (Call-In)') return null
        const key = rundownToggled ? 'run_out_date_with_drops' : 'run_out_date'
        return a[key] < b[key] ? 1 : -1
      },
      render: (_, row) => (
        <RunOutTimeCell row={row} rundownToggled={rundownToggled} monitoringStrategy={monitoringStrategy} />
      ),
    },

    {
      title: 'Percent Full',
      dataIndex: 'percent_filled',
      key: 'percent_filled',
      width: 200,
      render: (value, row) => {
        if (monitoringStrategy === 'No Readings (Call-In)') return null

        const inventory = row.estimated_inventory || row.measured_inventory
        return (
          <div className='flex items-center'>
            <div className='flex-1'>
              <TankFillBar
                className='store-monitoring-grid-percent-filled'
                fill={value}
                showWarning={TankHasWarning(row.run_out_date)}
                lowThreshold={0.5}
              />
            </div>
            <Texto className='px-3' weight='bold'>
              <b>{inventory && addCommasToNumber(inventory.toFixed(0))}</b>
            </Texto>
          </div>
        )
      },
    },
    {
      title: 'Max Volume',
      dataIndex: 'storage_max',
      key: 'storage_max',
      width: 100,
      render: (text) => addCommasToNumber(text),
    },
  ]
}

export function RunOutTimeCell({ row, rundownToggled = false, monitoringStrategy = '' }) {
  if (monitoringStrategy === 'No Readings (Call-In)') return null
  const date = rundownToggled ? row?.run_out_date_with_drops : row?.run_out_date
  return (
    <span className={ShowRunOutWarningClass(date || row?.run_out_date)}>
      {ReadableDifference(date || row?.run_out_date, undefined, true)}
    </span>
  )
}
